<!-- 工作台 -->
<template>
  <div id="clientList">
    <div class="flex search-kh">
      <div class="people-count">
        <span>访问数-{{accessCount}}人</span>
        <span class="ml-20">对话中-{{chatNum}}人</span>
      </div>
      <el-form class="identity-ctn ml-20" :inline="true">
        <el-form-item>
          <el-select
            v-model="searchData.uType"
            placeholder="用户类型"
            @change="GetTodayVisitorsList(1)"
            size="mini"
            style="width: 110px"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="车主" value="0"></el-option>
            <el-option label="企业" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item >
          <el-date-picker
            v-model="searchData.datetime"
            @change="GetTodayVisitorsList(1)"
            size="mini"
            type="date"
            value-format="yyyy-MM-dd"
            style="width: 150px"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-table
            v-show="showHistoryList"
            :header-cell-style="{background:'#F2F6FC'}"
            :data="clientList"
            height="350"
            border=""
            style="width: 100%">
      <el-table-column label="类型" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{scope.row.UTypeName}}</template>
      </el-table-column>
      <el-table-column label="渠道" width="180" :show-overflow-tooltip="true">
        <template slot-scope="scope">{{scope.row.Referer}}</template>
      </el-table-column>
      <el-table-column prop="Name" label="访客姓名" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="EntpName" label="所属企业" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="StayTime" label="停留时间" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="LastMinute" label="最后活动" :show-overflow-tooltip="true"></el-table-column>
      <!-- <el-table-column prop="SName" label="当前接待" :show-overflow-tooltip="true"></el-table-column> -->
      <el-table-column prop="UnreadNum" label="未读消息" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">{{scope.row.OperationType|stateHandle}}</template>
      </el-table-column>
      <el-table-column label="操作" width="250px">
        <template slot-scope="scope">
          <!-- 对话与预约功能只有当前接待人才允许 -->
          <el-button
            v-if="scope.row.OperationType == 1"
            type="primary"
            size="small"
            @click="leaveMessage(scope.row)"
          >留言</el-button>
          <el-button
            v-else-if="scope.row.OperationType == 2&&scope.row.IsCurrentAccess"
            type="primary"
            size="small"
            @click="chatWith(scope.row)"
          >对话</el-button>
          <el-button true type="primary" size="small" @click="showClientDetail(scope.row)">查看</el-button>
          <el-button
            v-if="scope.row.UType == 0&&scope.row.IsCurrentAccess"
            type="primary"
            size="small"
            @click="openReservarion(scope.row.Uid,'')"
          >预约</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="open-icon"  @click="showHistory" v-show="!showHistoryList">
      <img src="../../assets/images/open-msg.png">
    </div>
    <el-dialog title="客户详情" :visible.sync="clientDetailDialogVisible" width="90%">
      <div v-if="clientDetail.type==0">
        <div>
          <div class="unit">
            <span class="unit-name">客户姓名:</span>
            <label class="unit-label">{{clientDetail.name}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">客户类型:</span>
            <label class="unit-label">{{clientDetail.typeName}}</label>
          </div>
        </div>
        <div>
          <div class="unit">
            <span class="unit-name">手机号:</span>
            <label class="unit-label">{{clientDetail.phone}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">邮箱:</span>
            <label class="unit-label">{{clientDetail.email}}</label>
          </div>
        </div>
        <div>
          <div class="unit" style="width: 100%;">
            <span class="unit-name">地址:</span>
            <label class="unit-label" style="width: 81%;">{{clientDetail.address}}</label>
          </div>
        </div>
        <div>
          <div class="unit">
            <span class="unit-name">车型描述:</span>
            <label class="unit-label">{{clientDetail.seriesDesc}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">车架号:</span>
            <label class="unit-label">{{clientDetail.vehicleCode}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">车牌号:</span>
            <label class="unit-label">{{clientDetail.carNum}}</label>
          </div>
        </div>
      </div>
      <div v-else-if="clientDetail.type==1">
        <div>
          <div class="unit">
            <span class="unit-name">客户姓名:</span>
            <label class="unit-label">{{clientDetail.name}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">客户类型:</span>
            <label class="unit-label">{{clientDetail.typeName}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">所属公司:</span>
            <label class="unit-label">{{clientDetail.entpName}}</label>
          </div>
        </div>
        <div>
          <div class="unit">
            <span class="unit-name">公司类型:</span>
            <label class="unit-label">{{clientDetail.entpTypeName}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">联系方式:</span>
            <label class="unit-label">{{clientDetail.entpPhone}}</label>
          </div>
        </div>
        <div>
          <div class="unit">
            <span class="unit-name">手机号:</span>
            <label class="unit-label">{{clientDetail.phone}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">微信号:</span>
            <label class="unit-label">{{clientDetail.wechat}}</label>
          </div>
          <div class="unit">
            <span class="unit-name">邮箱:</span>
            <label class="unit-label">{{clientDetail.email}}</label>
          </div>
        </div>
        <div>
          <div class="unit" style="width: 100%;">
            <span class="unit-name">地址:</span>
            <label class="unit-label" style="width: 81%;">{{clientDetail.address}}</label>
          </div>
        </div>
        <div>
          <div class="unit" style="width: 100%;">
            <span class="unit-name">主营车型:</span>
            <label class="unit-label" style="width: 81%;">{{clientDetail.mainManageSeries}}</label>
          </div>
        </div>
        <div>
          <div class="unit" style="width: 100%;">
            <span class="unit-name">主营配件:</span>
            <label class="unit-label" style="width: 81%;">{{clientDetail.mainManageAutoParts}}</label>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="维修预约"
      :visible.sync="reservarionDialogVisible"
      :close-on-click-modal="false"
      @close="controlReservarionVisible(false)"
    >
      <reservarionDialog
        ref="reservarionDialog"
        :cid="rr_cid"
        :entpId="rr_entpId"
        @controlReservarionVisible="controlReservarionVisible"
      ></reservarionDialog>
    </el-dialog>
  </div>
</template>
<script>
import reservarionDialog from "@/components/workbench/reservarionDialog.vue";
export default {
  name: "clientList",
  components: {
    reservarionDialog
  },
  props: {
    msg: String
  },
  data() {
    return {
      showHistoryList:true,
      userMsg: "",
      chatNum: 0,
      accessCount: 0,
      clientDetailDialogVisible: false,
      clientDetail: {},
      tableHeaderStyle: {
        background: "#000 !important"
      },
      clientList: [],
      searchData: {
        uType: "-1",
        datetime:"",
      },
      reservarionDialogVisible: false,
      rr_cid: "",
      rr_entpId: ""
    };
  },
  filters: {
    stateHandle(val) {
      let value = Number(val);
      let result = "";
      if (value == 0) {
        result = "对话中";
      } else if (value == 1) {
        result = "离线";
      } else if (value == 2) {
        result = "在线";
      } else if (value == 3) {
        result = "未接入";
      }

      return result;
    }
  },
  mounted() {
    //当前登录客服
    // this.userMsg = this.$util.getSessionStorage("userMsg").Id;
    this.GetTodayVisitorsList();
  },
  methods: {
    hideHistory(){
      this.showHistoryList = false
    },
    showHistory(){
      this.showHistoryList = true
    },
    //获取今日访客
    GetTodayVisitorsList(showLoading) {
      this.axios
        .get("/ChatCenter/GetTodayVisitors", {
          params: this.searchData,
          hideloading: showLoading ? false : true
        })
        .then(response => {
          let _data = response.data.data;
          this.clientList = _data;
          this.accessCount = _data.length;
          let _chatNum = 0;
          for (let i = 0; i < _data.length; i++) {
            if (_data[i].OperationType == 0) {
              _chatNum += 1;
            }
          }
          this.chatNum = _chatNum;
        });
    },
    // 对话
    chatWith(item) {
      if (this.$store.state.connectState != 2) {
        this.$message({
          message: "请先点击右上方按钮连接客服",
          type: "warning"
        });
        return;
      }
      // this.$emit('chatWith',item)
      this.$emit("addCustomerToChattingList", item); //放到conversation组件处理逻辑
    },
    // 留言
    leaveMessage(item) {
      if (this.$store.state.connectState != 2) {
        this.$message({
          message: "请先点击右上方按钮连接客服",
          type: "warning"
        });
        return;
      }

      var kh = {
        avatarUrl: "",
        isJoin: false,
        isLeave: true,
        uId: item.Uid,
        uName: item.Name,
        uType: item.UType,
        refererName:item.Referer
      };
      //改变当前对话客户
      this.$store.commit("updateCustomerMsg", kh); //不经过conversation组件，在chat与dailyOperation组件监听事件处理
      // this.$emit('leaveWith',item)
    },
    //客户详情
    showClientDetail(item) {
      let that = this;
      this.axios
        .get("/ClientManagement/GetClientDetail", {
          params: { uid: item.Uid, utype: item.UType },
          hideloading: false
        })
        .then(resp => {
          let data = resp.data.data;
          if (resp.data.errcode == 0 && data) {
            that.clientDetail = data;
            that.clientDetailDialogVisible = true;
          } else {
            this.$message.error("客户不存在！");
          }
        });
    },
    openReservarion(cid, entpId) {
      if (this.$store.state.connectState != 2) {
        this.$message({
          message: "请先点击右上方按钮连接客服",
          type: "warning"
        });
        return;
      }
      //这里使用watch监听和父组件调用子组件的方式去初始化弹窗内的数据
      //使用两种的原因是,1.监听的参数值不必是不会触发watch事件的，2.预约弹窗未打开过父级无法找到他
      if (this.$refs.reservarionDialog != undefined) {
        this.$refs.reservarionDialog.initializationData(cid, entpId);
      } else {
        this.rr_cid = cid;
        this.rr_entpId = entpId;
      }
      this.controlReservarionVisible(true);
    },
    //关闭预约弹窗
    controlReservarionVisible(item) {
      this.reservarionDialogVisible = item;
    }
  }
};
</script>
<style lang="less" scoped>
.search-kh {
  align-items: center;
  position: absolute;
  top: 0;
  right: 310px;
  // width: 300px;
  height: 60px;
  z-index: 99;
  color: white;
}
.people-count {
  width: 200px;
  display: flex;
  align-items: center;
  height: 60px;
  z-index: 99;
  color: white;
}
.unit {
  width: 30%;
  display: inline-block;
  margin: 10px 0;
}
.unit-name {
  display: inline-block;
  width: 70px;
  height: 32px;
  line-height: 32px;
  text-align: right;
}
.unit-label {
  display: inline-block;
  width: 70%;
  height: 32px;
  line-height: 32px;
  vertical-align: middle;
  margin-left: 10px;
  padding-left: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
.open-icon {
  cursor: pointer;
  padding: 10px;
  border: 1px solid @border3Color;
  margin-bottom: 10px;
  text-align: center;
  img {
    height: 20px;
    width: auto;
  }
}
</style>

